// Remember to not import editor stuff in here as this needs to be used outside of lazy loads
import React, { createContext, useContext, useMemo, useState } from 'react';
/**
 * Stores the ref to the editor for convenient access outside
 * the main editor tree.
 */ export const EditorContext = /*#__PURE__*/ createContext({
    isReady: false,
    isEmpty: true,
    setIsReady: ()=>null,
    setIsEmpty: ()=>null
});
/**
 * Hook to access the current editor ref
 */ export const useEditorContext = ()=>{
    const context = useContext(EditorContext);
    if (!context) {
        throw new Error('useEditorContext must be used within a EditorContextProvider');
    }
    return context.ref;
};
/**
 * Wrap your components that need editor api access
 *
 * Important, use once per instance
 */ export const EditorContextProvider = ({ children })=>{
    const [ref, setRef] = useState();
    const [isReady, setIsReady] = useState(false);
    // We have to track isEmpty separately because the editor object doesn't cause context updates as editor content changes
    const [isEmpty, setIsEmpty] = useState(true);
    const value = useMemo(()=>({
            ref,
            setRef,
            isReady,
            setIsReady,
            isEmpty,
            setIsEmpty
        }), [
        ref,
        isReady,
        isEmpty
    ]);
    return /*#__PURE__*/ React.createElement(EditorContext.Provider, {
        value: value
    }, children);
};
/**
 * Stores the measured container size
 */ export const EditorContainerSizeContext = /*#__PURE__*/ createContext({});
/**
 *  Container size provider
 */ export const EditorContainerSizeContextProvider = ({ children })=>{
    const [containerSize, setContainerSize] = useState();
    const value = useMemo(()=>({
            containerSize,
            setContainerSize
        }), [
        containerSize
    ]);
    return /*#__PURE__*/ React.createElement(EditorContainerSizeContext.Provider, {
        value: value
    }, children);
};
/**
 * Hook to access the current editor ref
 */ export const useEditorContainerSize = ()=>{
    const context = useContext(EditorContainerSizeContext);
    if (!context) {
        throw new Error('useEditorContainerSize must be used within a EditorContainerSizeContextProvider');
    }
    return context.containerSize;
};
/**
 * Wrap your editors in this
 */ export const EditorContextProviderWrapper = ({ children })=>{
    return /*#__PURE__*/ React.createElement(EditorContextProvider, null, /*#__PURE__*/ React.createElement(EditorContainerSizeContextProvider, null, children));
};

//# sourceMappingURL=Context.js.map